import { render, staticRenderFns } from "./kryptStakesInput.vue?vue&type=template&id=62a365e3&scoped=true&"
import script from "./kryptStakesInput.vue?vue&type=script&lang=js&"
export * from "./kryptStakesInput.vue?vue&type=script&lang=js&"
import style0 from "./kryptStakesInput.vue?vue&type=style&index=0&id=62a365e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a365e3",
  null
  
)

export default component.exports